import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
    palette: {
    type: 'light',
    },
});